import type { ISerialize } from '@/objects/ISerialize';
import type { ExternalDatasourceType } from './../enums/ExternalDatasourceType';

export class ExternalDataSource implements ISerialize {
    public LogoSource: string | null;

    public Name: string;

    public Type: ExternalDatasourceType;

    public Url: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { LogoSource?: string | null; Name?: string | null; Type?: ExternalDatasourceType; Url?: string | null }) {
        this.LogoSource = values.LogoSource ?? '';

        this.Name = values.Name ?? '';

        this.Type = values.Type ?? 'Oauth';

        this.Url = values.Url ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"LogoSource": ${JSON.stringify(this.LogoSource)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"Type": ${this.Type == 'Oauth' ? 0 : this.Type == 'Bearer' ? 1 : this.Type == 'FileDrop' ? 2 : 0}` +
            ',' +
            `"Url": ${JSON.stringify(this.Url)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ExternalDataSource from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        LogoSource?: string | null;
        Name?: string | null;
        Type?: ExternalDatasourceType;
        Url?: string | null;
    }): ExternalDataSource {
        return new ExternalDataSource(values);
    }

    public static _FromServerJson(json: any): ExternalDataSource {
        return new ExternalDataSource({
            LogoSource: json.LogoSource ?? '',
            Name: json.Name ?? '',
            Type: json.Type == 0 ? 'Oauth' : json.Type == 1 ? 'Bearer' : json.Type == 2 ? 'FileDrop' : 'Oauth',
            Url: json.Url ?? '',
        });
    }

    /**
     * Creates an instance of ExternalDataSource from another instance of ExternalDataSource.
     * @param other The ExternalDataSource you want to clone
     * @returns A cloned ExternalDataSource
     */
    public static FromOther(other: ExternalDataSource): ExternalDataSource {
        return ExternalDataSource._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ExternalDataSource.FromOther(this);
    }

    static NAME_OF_CLASS = 'ExternalDataSource';
}
